/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Caret-Up': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.8009 7.81918L6.89797 15.0626C6.7917 15.2182 6.90538 15.4286 7.0969 15.4286L16.9027 15.4286C17.0942 15.4286 17.2079 15.2182 17.1028 15.0626L12.1987 7.81918C12.1048 7.67935 11.896 7.67935 11.8009 7.81918Z" />'
  }
})
